// UnitPortrait.tsx
import React from 'react';
import { FactionType, type BattleUnit } from '@/core/types/battle.types';
import { getUnitTotalHp } from '@/core/utils/battle.utils';
import { BattleBus } from '@/events/Events';

const TILE = 96;
const WINDOW = 80;
const SCALE = WINDOW / TILE;
const SHEET_W = 4 * TILE * SCALE;
const SHEET_H = 2 * TILE * SCALE;

export function UnitPortrait({ unit }: { unit: BattleUnit }) {
    const hpPercent = (getUnitTotalHp(unit) / unit.maxUnitHp) * 100;
    const portrait = unit.unitPortrait;
    const focusOnUnit = () => {
        BattleBus.emit('FOCUS_ON_UNIT', {unitId: unit.unitId, force: true});
    }

    return (
        <div className="portrait-module" onClick={focusOnUnit}>
            <div className="portrait-content">
                {portrait ? (
                    <div
                        className="portrait-sprite"
                        style={{
                            backgroundSize: `${SHEET_W}px ${SHEET_H}px`,
                            backgroundPosition: `-${portrait.col * WINDOW}px -${portrait.row * WINDOW}px`,
                            transform: unit.faction !== FactionType.Player ? 'scaleX(-1)' : 'none',
                        }}
                    />
                ) : (
                    <div className="portrait-placeholder">{unit.unitId.substring(0, 2)}</div>
                )}
            </div>
            <div className="hp-bar-inset">
                <div className="hp-bar-fill" style={{ height: `${hpPercent}%` }} />
            </div>
            <div className="portrait-count">{unit.count}</div>
            <div className="frame-overlay" />
        </div>
    );
}